export default "__VITE_ASSET__Bfe3baqX__"